<template><div><h1 id="verkaufer" tabindex="-1"><a class="header-anchor" href="#verkaufer"><span>Verkäufer</span></a></h1>
<p>Verkäufer — Verkäufer mit Kommissionen und Fixbeträgen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden Verkäufer eingetragen. Optional können Kommissionen (%-Anteil des Umsatzes) oder Fixbeträge (pro Sammelrechnung) festgelegt werden.</p>
<p>Pfad: <code v-pre>Verkauf → Verkäufer</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Code (Unique Identifier pro Mandant)</dd>
<dt>Verkäufer</dt>
<dd>Personen-ID des Verkäufers</dd>
<dt>Organisation</dt>
<dd>Personen-ID der Organisation</dd>
<dt>Kommission %</dt>
<dd>Kommission in % des Umsatzes</dd>
<dt>Fixum CHF</dt>
<dd>Fixbetrag zum Gesamt-Umsatz der Adresse</dd>
<dt>Fixum, wenn Prozent zu klein?</dt>
<dd>Option=&quot;ja&quot;:Der Fixum-Betrag wird ausbezahlt, wenn das Total des Kommissionsbetrages kleiner als das Fixum ist.<br>Option=&quot;nein&quot;: Der Fixum-Betrag wird ausbezahlt, zusätzlich zu einem allfällig vorhandenen Kommissionsbetrag.</dd>
<dt>Mandant</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandanten</a></dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


